export default __webpack_public_path__ + "static/media/VrundaPathare.470f3839.png";